export default __webpack_public_path__ + "static/media/parking.e7427e63.jpg";